import React__default, { useCallback } from 'react';
import { useTreeItem, TreeItem } from '@mui/lab';
import { Checkbox, Typography, Box, LinearProgress } from '@mui/material';
import clsx from 'clsx';
import DefaultIcon from '../../../DefaultIcon/index.js';

var useTreeFieldItem = function (isOptionSelected, handleExpand, handleSelectOption, multiple, KIcon) {
    if (KIcon === void 0) { KIcon = DefaultIcon; }
    var treeRender = useCallback(function (option) {
        var _a, _b, _c;
        return (React__default.createElement(TreeItem, { tabIndex: 0, key: option.id.toString(), sx: {
                "& .MuiTreeItem-content  .MuiTreeItem-iconContainer": {
                    width: "unset",
                    alignItems: "center"
                }
            }, nodeId: option.id.toString(), label: React__default.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
                React__default.createElement(Box, null, option.label),
                React__default.createElement(Box, { sx: { flexGrow: 1 } }, option.childrenLoading && (React__default.createElement(LinearProgress, { sx: {
                        marginLeft: 1,
                        marginRight: 1
                    } })))), collapseIcon: React__default.createElement(KIcon, { sx: {
                    visibility: ((_a = option.children) === null || _a === void 0 ? void 0 : _a.length) === 0 ? "hidden" : "visible"
                }, className: "fa-regular fa-chevron-down" }), expandIcon: React__default.createElement(KIcon, { sx: {
                    visibility: ((_b = option.children) === null || _b === void 0 ? void 0 : _b.length) === 0 ? "hidden" : "visible"
                }, className: "fa-regular fa-chevron-right" }), ContentComponent: TreeViewItem, ContentProps: {
                option: option,
                multiple: multiple,
                isOptionSelected: isOptionSelected,
                handleExpand: handleExpand,
                handleSelectOption: handleSelectOption
            } },
            React__default.createElement(React__default.Fragment, null, (_c = option.children) === null || _c === void 0 ? void 0 : _c.map(function (node) { return treeRender(node); }))));
    }, [KIcon, handleExpand, handleSelectOption, isOptionSelected, multiple]);
    return {
        treeRender: treeRender
    };
};
var TreeViewItem = React__default.forwardRef(function CustomContent(props, ref) {
    var _a;
    var classes = props.classes, className = props.className, label = props.label, nodeId = props.nodeId, iconProp = props.icon, expansionIcon = props.expansionIcon, displayIcon = props.displayIcon, option = props.option, multiple = props.multiple, isOptionSelected = props.isOptionSelected, handleExpand = props.handleExpand, handleSelectOption = props.handleSelectOption;
    var _b = useTreeItem(nodeId), disabled = _b.disabled, expanded = _b.expanded, selected = _b.selected, focused = _b.focused;
    var icon = iconProp || expansionIcon || displayIcon;
    return (React__default.createElement("div", { className: clsx(className, classes.root, (_a = {},
            _a[classes.expanded] = expanded,
            _a[classes.selected] = selected,
            _a[classes.focused] = focused,
            _a[classes.disabled] = disabled,
            _a)), ref: ref },
        React__default.createElement("div", { onClick: function (event) {
                // Don't close tree while expanding options (useful in single selection mode)
                event.stopPropagation();
                handleExpand(Number.parseInt(nodeId));
            }, className: classes.iconContainer }, icon),
        multiple && (React__default.createElement(Checkbox, { checked: isOptionSelected(option.id), onChange: function () { return handleSelectOption(option); }, onClick: function (event) { return event.stopPropagation(); }, disableRipple: true, size: "small", sx: { padding: 0, marginRight: function (theme) { return theme.spacing(1); } }, "data-testid": "".concat(option.label, "-selecteur") })),
        React__default.createElement(Typography, { onClick: function () { return handleSelectOption(option); }, component: "div", className: classes.label }, label)));
});

export { useTreeFieldItem };
//# sourceMappingURL=hooks.js.map
